import { useTranslate } from '../../hooks'
import { GetHand } from '@repo/ui/components/icons'
import { Typography } from '@repo/ui/components/typography'

export function OrderbookTradesEmpty() {
  const { t } = useTranslate()
  return (
    <Typography className='flex flex-col items-center justify-center py-2xl'>
      <GetHand className='mb-lg size-14' />
      <Typography color='text-neutral-surface-60' size='xs'>
        {t('orderbook_no_trades')}
      </Typography>
    </Typography>
  )
}
